import { SpendAreaStage } from '@sib/api';

export const spendAreaStageColors: Record<SpendAreaStage, string> = {
  [SpendAreaStage.MOBILIZATION]: 'hsl(var(--accent-blue))',
  [SpendAreaStage.SPEND_ESTIMATED]: 'hsl(var(--accent-pink))',
  [SpendAreaStage.NEGOTIATIONS]: 'hsl(var(--warning-vivid))',
  [SpendAreaStage.SAVINGS_REALIZED]: 'hsl(var(--success-vivid))',
  [SpendAreaStage.MONITORING_SAVINGS]: 'hsl(var(--accent-violet-vivid))',
};
